import React from 'react'
import logo_light from '../assets/logo-light.webp'
import { FaFacebookF } from 'react-icons/fa'
import { FaTwitter } from 'react-icons/fa'
import { FiInstagram } from 'react-icons/fi'

export default function Footer() {
  return (
    <div className='flex flex-wrap justify-between flex-col sm:flex-row gap-8 bg-[rgb(63,65,153)] text-gray-300 py-20 xl:px-[9vw] px-4 font-sans ' >
      <div>
        <img src={logo_light} alt="logo_light" />
        <p className='py-8' >Dental care is maintenance of <br /> healthy teeth and cleaning <br /> mouth for beautiful smile</p>
        <div className='flex gap-2' >
          <FaFacebookF className='border rounded-full h-10 p-2 w-10  hover:bg-green-800' />
          <FaTwitter className='border rounded-full  h-10 p-2 w-10 hover:bg-green-800' />
          <FiInstagram className='border rounded-full h-10 p-2 w-10 hover:bg-green-800' />
        </div>
      </div>
      <div>
        <h1 className='text-white text-3xl pb-3  font-myfont ' >Our Services</h1>
        <p>General Dentistry</p>
        <p>Oral Surgery</p>
        <p>Dental Bridge</p>
        <p>Root Canals</p>
        <p>Cosmetic Braces</p>
        <p>Pediatric Dentistry</p>
      </div>
      <div>
        <h1 className='text-white text-3xl pb-3 font-myfont' >Importance</h1>
        <p>About us</p>
        <p>Company</p>
        <p>Terms & Conditions</p>
        <p>24/7 Advance Care</p>
        <p>Emergency Centre</p>
        <p>Payment System</p>
      </div>
      <div>
        <h1 className='text-white text-3xl pb-3 font-myfont'>Contact us</h1>
        <p>256B, West Site House </p>
        <p> Main Town, New York</p>
        <p> +98745 612 301 </p>
        <p> +95874 102 201 </p>
        <p> info@example.com </p>
        <p> www.predent.com </p>
      </div>

    </div>
  )
}
